/**
 * Pano sayfası — Power BI embed'i (`Dashboard.js`) yerine geçecek ekran.
 *
 * Sayfa yalnız kabuk işini yapar: son gezilen yolu hatırlatır ve panoyu
 * kaplama olarak çizer. Grafiklerin tamamı `Components/SmartOptDashboard`
 * altında, sekme sekme tanımlıdır.
 */
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmartOptDashboard from "../Components/SmartOptDashboard/SmartOptDashboard";
import TableContext from "../Context/TablePosition";

const PanoPage = () => {
  const { setCurrentUrl } = useContext(TableContext);
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("urlpaintshop", location.pathname);
    setCurrentUrl(localStorage.getItem("urlpaintshop"));
  }, [location.pathname, setCurrentUrl]);

  return (
    <div className="flex h-full w-full flex-col">
      <SmartOptDashboard />
    </div>
  );
};

export default PanoPage;
